import {
  FETCH_ASSIGN_TASK_TO_ANOTHER_USER_REQUEST,
  FETCH_ASSIGN_TASK_TO_ANOTHER_USER_SUCCESS,
  FETCH_ASSIGN_TASK_TO_ANOTHER_USER_FALUIRE,
} from './assignTaskToAnotherUserTypes'

const initialState = {
  loading: false,
  assignTaskToAnotherUser: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_ASSIGN_TASK_TO_ANOTHER_USER_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_ASSIGN_TASK_TO_ANOTHER_USER_SUCCESS : return {
      ...state,
      assignTaskToAnotherUser: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_ASSIGN_TASK_TO_ANOTHER_USER_FALUIRE : return {
      ...state,
      loading: false,
      assignTaskToAnotherUser: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
